import React, { useState, useEffect } from "react";
import bitcoin from "../../src/stock/bitcoin-btc-logo.png"
import Eth from "../../src/stock/ethereum-eth-logo.png"
import USDT from "../../src/stock/tether-usdt-logo.png"
import sol from "../../src/stock/solana-sol-logo.png"
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import "aos/dist/aos.js";
import { FaStar } from "react-icons/fa";

function Home() {
    const [selected, setSelected] = useState(null);

    const toggle = (i) => {
      if (selected === i) {
        return setSelected(null); // Close if clicked again
      }
      setSelected(i);
    };
  
    const faqData = [
      {
        question: "What is the minimum investment amount?",
        answer: "The minimum investment amount is $100. This allows both beginners and experienced traders to start building their portfolios with ease."
      },
      {
        question: "How long before I start seeing returns?",
        answer: "Returns vary based on market conditions and the traders you choose to copy. Many users begin seeing consistent performance within the first few days to the minimum trading duration which is 30 days."
      },
        {
        question: "How do I withdraw my profits?",
        answer:
          "Withdrawals can be requested anytime directly from your dashboard. All payout requests are processed within 24 hours."
      },
        {
    question: "Is copy trading safe for beginners?",
    answer:
      "Yes. NexusForge FX is designed with beginners in mind. You can copy experienced traders, use risk-management tools, and follow strategies without needing advanced trading knowledge."
  },
    {
    question: "Can I choose which traders to copy?",
    answer:
      "Absolutely. You can view detailed stats, performance history, risk scores, and profitability of each trader before deciding who to copy."
  },
    {
    question: "Are my funds secure?",
    answer:
      "Yes. We use advanced encryption, secure wallet systems, and multi-layer protection to ensure your funds and data remain safe at all times."
  },
  {
    question: "How do deposits work?",
    answer:
      "You can deposit using major cryptocurrencies such as Bitcoin, Ethereum, USDT, and Solana. Deposits confirm quickly, making it easy to start trading in minutes."
  },
      {
        question: "What cryptocurrencies do you trade?",
        answer: "We trade Bitcoin, Ethereum, USDT, Solana, and other popular cryptocurrencies."
      },  {
    question: "Do I need prior trading experience?",
    answer:
      "No experience is required. The platform is beginner-friendly, and copy trading lets you follow experts while learning at your own pace."
  },
      {
        question: "How do I withdraw my profits?",
        answer: "You can withdraw profits anytime directly from your dashboard. We process withdrawals within 24 hours."
      }
    ];

    //
    const { hash } = useLocation();

    useEffect(() => {

      
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash.replace('#', ''));
          if (element) {
            const offset = element.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 2) + (element.clientHeight / 2);
            window.scrollTo({ top: offset, behavior: 'smooth' });
          }
        }, 100); // Adjust delay as needed
      }
    }, [hash]);

    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
      document.title = "Nexusforge Fx"

      if (!hasMounted) {
        setHasMounted(true);
        AOS.init({
          delay: 200,
        });
      } else {
        AOS.refresh();
      }
    }, [hasMounted]);

  const testimonials = [
  {
    name: "Michael Collins",
    title: "Beginner Trader",
    image: "https://randomuser.me/api/portraits/men/12.jpg",
    quote:
      "NexusForge FX changed everything for me. I started copy-trading with just $10,000, and within weeks I was seeing consistent profits. The platform is simple, clean, and beginner-friendly."
  },
  {
    name: "Sarah Johnson",
    title: "Crypto Investor",
    image: "https://randomuser.me/api/portraits/women/45.jpg",
    quote:
      "I love how transparent the platform is. You can see the performance of top traders before copying them. My portfolio has grown faster than I expected."
  },
  {
    name: "Daniel keke",
    title: "Entrepreneur",
    image: "https://randomuser.me/api/portraits/men/33.jpg",
    quote:
      "NexusForge FX makes trading feel effortless. I can track every move in real time, manage my exposure easily, and copy top traders without stress. It’s the smoothest platform I’ve ever used."
  },
  {
    name: "Grace Williams",
    title: "Marketing Consultant",
    image: "https://randomuser.me/api/portraits/women/52.jpg",
    quote:
      "I used to struggle with my time learn crypto trading, but NexusForge FX made it simple. Copy trading allowed me to earn while doing other things. Highly recommended!"
  },
  {
    name: "Carlos Mendes",
    title: "Data Analyst",
    image: "https://randomuser.me/api/portraits/men/65.jpg",
    quote:
      "The platform's insights and real-time data are always accurate. I’ve been able to make smarter trades, and the results speak for themselves."
  },
  {
    name: "Bennett Gracie",
    title: "Full-Time Trader",
    image: "https://randomuser.me/api/portraits/women/68.jpg",
    quote:
      "NexusForge FX gave me access to high-performing traders I couldn’t find elsewhere. My earnings have doubled since I switched to this platform."
  }
];


const services = [
  {
    title: "Top Trader Filters",
    desc: "We find the best traders using real performance data, so you only copy people who know what they’re doing.",
    img: "https://unpkg.com/lucide-static/icons/filter.svg",
  },
  {
    title: "Copy Trading",
    desc: "Pick a trader you like and mirror their moves automatically. No complex charts needed.",
    img: "https://unpkg.com/lucide-static/icons/share-2.svg",
  },
  {
    title: "Risk Control Tools",
    desc: "Set limits, stop losses, and manage how much you want to invest with simple controls.",
    img: "https://unpkg.com/lucide-static/icons/shield-check.svg",
  },
  {
    title: "Real-Time Insights",
    desc: "See live stats, profits, win rates, and trade history to make better decisions.",
    img: "https://unpkg.com/lucide-static/icons/bar-chart-3.svg",
  },
  {
    title: "Market Updates",
    desc: "Get clear market news and short updates that help you understand what’s happening.",
    img: "https://unpkg.com/lucide-static/icons/newspaper.svg",
  },
  {
    title: "24/7 Support",
    desc: "Get quick help anytime through our support channels, whether you’re new or skilled.",
    img: "https://unpkg.com/lucide-static/icons/headset.svg",
  },
];




  
  return (
    <div className='page home'>
        <div className="page-_container">

            <div className="landing">
                <div className="landing-content-container">
                 <h1   data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-once="true">Empower Your Future with Smarter Trading</h1>
                 <p   data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-once="true">At Nexusforge FX, We handpick the best traders worldwide and give you a simple platform where anyone—beginner or pro—can copy their strategies and grow with them.</p>
                 <div className="buttons"   data-aos="zoom-in"
            data-aos-duration="1000"
            data-aos-once="true">
                     <NavLink >Learn More</NavLink>
                     <NavLink>Start Trading</NavLink>
                 </div>
                </div>
            </div>

            <div className="records">
                <div className="record-container">
                    <div className="record" 
                      // data-aos="zoom-in"
                    data-aos-duration="100"
                    data-aos-once="true">
                        <h3>10,000+</h3>
                        <p>Successful Traders</p>
                    </div>
                    <div className="record"
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">
                        <h3>$100,000+</h3>
                        <p>Daily Trade Volume</p>
                    </div>
                    <div className="record"
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">
                        <h3>3+</h3>
                        <p>Market Experience</p>
                    </div>
                    <div className="record"
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">
                        <h3>24/7</h3>
                        <p>Client Support</p>
                    </div>
                </div>
            </div>

            <section id="how" className="services service">
             
             <div className="service-container">

                <div className="right"
                data-aos="zoom-out-right"
                  data-aos-duration="800"
                  data-aos-once="true">

                </div>

                <div className="left">
                    <h4
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">How It Works</h4>
                    <h1
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">Trade {" "} <span className="highlight">Smarter</span> with NexusForge FX</h1>
                    <p
                      data-aos="zoom-in"
                      data-aos-duration="800"
                      data-aos-once="true">NexusForge FX gives you easy access to the global crypto market. You get strong trading tools, real-time prices, fast and secure transactions, and support whenever you need it. Whether you’re a first-timer or a skilled trader, the platform keeps everything simple, clear, and safe.
                      </p>
                      <div  
                        data-aos="zoom-in"
                      data-aos-duration="500"
                      data-aos-once="true">
                    <NavLink to='/signup'
                   >Create Your Account</NavLink>
                      </div>
                </div>
             </div>
            </section>

             <section className="services-section">
      <div className="services-left">
        <p className="small-text">WHAT WE DO?</p>
        <h2>
          The service we offer is {" "} <span className="highlight">specifically</span> designed to meet
          your needs.
        </h2>
        <p className="desc">
      At NexusForge FX, we make trading easier by letting you copy the best traders in the world. We filter top performers, show their results clearly, and give you simple tools to follow their trades with confidence — even if you’re new.
        </p>
        <button className="btn">See Our Prices</button>
      </div>

      <div className="services-right">
        {services.map((item, index) => (
          <div className="service-card" key={index}>
            <img src={item.img} alt={item.title} />
            <div className="text">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
            
            <section id="tradables" className="services assets">
             
             <div className="service-container">

                <div className="left">
                <h4
                data-aos="zoom-in"
                data-aos-duration="800"
                data-aos-once="true"
                >Tradable Assets</h4>
                    <h1
                    data-aos="zoom-in"
                    data-aos-duration="800"
                    data-aos-once="true"
                    >Start Trading in Minutes and Watch Your {""} <span className="highlight">Portfolio</span>  Grow</h1>
                    <p
                    data-aos="zoom-in"
                    data-aos-duration="800"
                    data-aos-once="true"
                    >We support deposits and withdrawals in the most popular cryptocurrencies, making it easy to start trading without delays. With fast processing and flexible asset options, building and growing your portfolio becomes simple, secure, and convenient.
                    </p>
                    <div
                    data-aos="zoom-in"
                    data-aos-duration="500"
                    data-aos-once="true"
                    > 
                    <NavLink to='/signup'>Get Started Today</NavLink>
                    </div>
                </div>


                <div className="right coins">
                    <div className="container">
                        <div className="box"
                       data-aos="zoom-in-right"
                        data-aos-once="true"
                        >
                            <img src={bitcoin} alt="bitcoin" />
                            <p>Bitcoin</p>
                        </div>
                        <div className="box"
                         data-aos="zoom-in-left"
                           data-aos-once="true"
                        >
                        <img src={USDT} alt="USDT" />
                            <p>USDT</p>
                        </div>
                        <div className="box"
                       data-aos="zoom-in-right"
                           data-aos-once="true"
                        >
                        <img src={sol} alt="sol" />
                            <p>Solana</p>
                        </div>
                        <div className="box"
                         data-aos="zoom-in-left"
                           data-aos-once="true"
                         >
                        <img src={Eth} alt="eth" />
                            <p>Ethereum</p>
                        </div>
                    </div>
                </div>

             </div>
            </section>

          <section className="testimonials">
            <div className="container">
                <div className="heading">
                <p className="subtitle">HAPPY CUSTOMERS</p>
                <h2>
                  Don't take our word for it. See what{" "}
                  <span className="highlight">customers</span> are saying about us.
                </h2>
              </div>
              <div className="grid">
                {testimonials.map((item, index) => (
                  <div className="card" key={index}>
                    <div className="stars">★★★★★</div>
                    <p className="quote">“{item.quote}”</p>
                    <div className="profile">
                      <img src={item.image} alt={item.name} />
                      <div className="info">
                        <h4>{item.name}</h4>
                        <p>{item.title}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>



            <section id="faqs" className="faq-section">
      <h1 className="faq-title"
         data-aos="zoom-in"
         data-aos-duration="500"
         data-aos-once="true"
      >Frequently Asked Questions</h1>
      <div className="faq-container">
        {faqData.map((item, i) => (
          <div className="faq-item" key={i}>
            <div className="faq-question" onClick={() => toggle(i)}>
              <h3 className="faq-header"
               data-aos="zoom-in"
               data-aos-duration="500"
               data-aos-once="true"
              >{item.question}</h3>
              <span>{selected === i ? "-" : "+"}</span>
            </div>
            <div className={selected === i ? "faq-answer show" : "faq-answer"}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

        </div>

            <div className="startNow">
                <div className="the-background">

                    <div className="content-container"
                     data-aos="zoom-out"
                     data-aos-duration="500"
                     data-aos-once="true"
                    >
                 <div className="left">
                <h2>Unlock the full potential of your forex/crypto trading <br /> with NexusForge FX.</h2>
                <p>Seamless, secure, and built for traders who want results.</p>
            </div>

                        <div className="right">
                            <NavLink to='/signup'>Get started</NavLink>
                            <NavLink to='/login'>Sign in</NavLink>
                        </div>
                    </div>
                </div>
            </div>

    </div>
  )
}

export default Home